import { Boolean, Record, String, Undefined } from "runtypes";
import { PERSONABLE_GRAVATAR_COLLECTION } from "./collections";
export const HasGravatar = Record({
  netID: String,
  present: Boolean
});
export const hasGravatar = async (db, netID) => {
  return HasGravatar.Or(Undefined).check(
    await db.collection(PERSONABLE_GRAVATAR_COLLECTION).findOne({ netID, invalidated: { $exists: false } })
  )?.present ?? false;
};
//# sourceMappingURL=gravatar.js.map
